import React from 'react';

function Home() {
  return (
    <div>
      <h1> Welcome to our Page!</h1>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit.
        Eligendi non quis exercitationem culpa nesciunt nihil aut nost
        rum explicabo reprehenderit optio amet ab temporibus asperiores quasi cupiditate.
        Voluptatum ducimus voluptates voluptas?
      </p>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit.
        Eligendi non quis exercitationem culpa nesciunt nihil aut nost
        rum explicabo reprehenderit optio amet ab temporibus asperiores quasi cupiditate.
        Voluptatum ducimus voluptates voluptas?
      </p>
    </div>
  );
}

export default Home;
